import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useConvex } from "convex/react";
import { useEffect } from "react";

import { syncNotificationPermissionToConvex } from "./notificationPermissionSync";

/** Native cold start + foreground resume: read push permission (no prompt) and sync to Convex. */
export function useNotificationPermissionSessionSync(deviceId: string | null) {
  const convex = useConvex();

  useEffect(() => {
    if (!deviceId || !Capacitor.isNativePlatform()) return;

    void syncNotificationPermissionToConvex(convex, deviceId);
  }, [convex, deviceId]);

  useEffect(() => {
    if (!deviceId || !Capacitor.isNativePlatform()) return;

    const listener = App.addListener("appStateChange", (event) => {
      if (event.isActive) {
        void syncNotificationPermissionToConvex(convex, deviceId);
      }
    });

    return () => {
      void listener.then((handle) => handle.remove());
    };
  }, [convex, deviceId]);
}
